import { render, staticRenderFns } from "./RiskTrack.vue?vue&type=template&id=ddae2d70&scoped=true"
import script from "./RiskTrack.vue?vue&type=script&lang=js"
export * from "./RiskTrack.vue?vue&type=script&lang=js"
import style0 from "./RiskTrack.vue?vue&type=style&index=0&id=ddae2d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddae2d70",
  null
  
)

export default component.exports